export const demoCampaigns = [
  {
    id: 'mie-bang-jono',
    slug: 'mie-bang-jono',
    title: 'Cerita Pedas Mie Bang Jono',
    brandName: 'Mie Bang Jono',
    category: 'F&B',
    location: 'Baubau, Sulawesi Tenggara',
    mapUrl: 'https://maps.google.com/?q=Mie+Bang+Jono+Baubau',
    tiktokUsername: 'miebangjono.official',
    instagramUsername: 'miebangjono',
    rate: 15000,
    maxViewsPerVideo: 100000,
    cover: '/images/campaign-food.svg',
    status: 'ACTIVE',
    creatorCount: 18,
    shortDescription: 'Bikin konten jujur tentang pengalaman makan mie pedas favorit warga Baubau.',
    description: 'Kami mencari creator lokal yang bisa mengemas pengalaman makan dengan gaya ringan, dekat, dan autentik.',
    brief: 'Tunjukkan suasana kedai, momen mencicipi menu, dan reaksi pertama saat mencoba level pedas pilihanmu.',
    requirements: ['Video 30–60 detik', 'Akun TikTok aktif dan publik', 'Cantumkan lokasi kedai', 'Konten tetap tayang minimal 30 hari'],
    budgetTotal: 15000000,
    budgetAvailable: 13500000,
  },
  {
    id: 'lume-skin-barrier',
    slug: 'lume-skin-barrier',
    title: '7 Hari Skin Barrier Journal',
    brandName: 'Lumé Studio',
    category: 'Beauty',
    location: 'Makassar, Sulawesi Selatan',
    mapUrl: 'https://maps.google.com/?q=Lume+Studio+Makassar',
    tiktokUsername: 'lumestudio.id',
    instagramUsername: 'lumestudio',
    rate: 22000,
    maxViewsPerVideo: 50000,
    cover: '/images/campaign-beauty.svg',
    status: 'ACTIVE',
    creatorCount: 24,
    shortDescription: 'Bagikan rutinitas sederhana untuk kulit yang terasa lebih tenang.',
    requirements: ['Wajah terlihat jelas', 'Konten original', 'Sertakan disclosure produk'],
    budgetTotal: 20000000,
    budgetAvailable: 15000000,
  },
  {
    id: 'sora-weekend-fit',
    slug: 'sora-weekend-fit',
    title: 'Weekend Fit Check',
    brandName: 'Sora Goods',
    category: 'Fashion',
    location: 'Kendari, Sulawesi Tenggara',
    mapUrl: 'https://maps.google.com/?q=Sora+Goods+Kendari',
    tiktokUsername: 'soragoods',
    instagramUsername: 'soragoods.id',
    rate: 18000,
    maxViewsPerVideo: 80000,
    cover: '/images/campaign-fashion.svg',
    status: 'ACTIVE',
    creatorCount: 11,
    shortDescription: 'Tampilkan satu look santai untuk akhir pekan di kotamu.',
    requirements: ['Full outfit terlihat', 'Gunakan audio yang relevan', 'Tag akun brand'],
    budgetTotal: 10000000,
    budgetAvailable: 8500000,
  },
  {
    id: 'ruang-rasa-retail',
    slug: 'ruang-rasa-retail',
    title: 'Temuan Lokal Minggu Ini',
    brandName: 'Ruang Rasa Market',
    category: 'Retail',
    location: 'Denpasar, Bali',
    mapUrl: 'https://maps.google.com/?q=Ruang+Rasa+Market+Denpasar',
    tiktokUsername: 'ruangrasa.bali',
    instagramUsername: 'ruangrasa.market',
    rate: 14000,
    maxViewsPerVideo: 60000,
    cover: '/images/campaign-retail.svg',
    status: 'ACTIVE',
    creatorCount: 9,
    shortDescription: 'Ajak audiens menemukan produk lokal yang layak masuk daftar belanja.',
    requirements: ['Rekam di dalam toko', 'Sorot minimal tiga produk', 'Gunakan tag lokasi'],
    budgetTotal: 8000000,
    budgetAvailable: 5600000,
  },
  {
    id: 'nala-coffee-morning',
    slug: 'nala-coffee-morning',
    title: 'Morning Ritual di Nala',
    brandName: 'Nala Coffee',
    category: 'F&B',
    location: 'Yogyakarta',
    mapUrl: 'https://maps.app.goo.gl/NalaCoffeeYogya',
    tiktokUsername: 'nalacoffee.official',
    instagramUsername: 'nalacoffee.id',
    rate: 20000,
    maxViewsPerVideo: 100000,
    cover: '/images/campaign-coffee.svg',
    status: 'ACTIVE',
    creatorCount: 31,
    shortDescription: 'Ceritakan ritual pagi dan satu menu yang bikin harimu mulai lebih baik.',
    requirements: ['Datang pukul 08.00–11.00', 'Tampilkan proses seduh', 'Video vertikal 9:16'],
    budgetTotal: 12000000,
    budgetAvailable: 10800000,
  },
  {
    id: 'karsa-slow-weekend',
    slug: 'karsa-slow-weekend',
    title: 'Slow Weekend Escape',
    brandName: 'Karsa Living',
    category: 'Lifestyle',
    location: 'Bandung, Jawa Barat',
    mapUrl: 'https://maps.google.com/?q=Karsa+Living+Bandung',
    tiktokUsername: 'karsaliving',
    instagramUsername: 'karsaliving.co',
    rate: 25000,
    maxViewsPerVideo: 50000,
    cover: '/images/campaign-lifestyle.svg',
    status: 'ACTIVE',
    creatorCount: 14,
    shortDescription: 'Buat cerita visual singkat tentang akhir pekan yang tenang dan bermakna.',
    requirements: ['Visual terang dan stabil', 'Narasi personal', 'Durasi maksimal 60 detik'],
    budgetTotal: 10000000,
    budgetAvailable: 6000000,
  },
]

export const demoCategories = [
  { id: 'food', name: 'F&B', slug: 'fnb' },
  { id: 'beauty', name: 'Beauty', slug: 'beauty' },
  { id: 'fashion', name: 'Fashion', slug: 'fashion' },
  { id: 'retail', name: 'Retail', slug: 'retail' },
  { id: 'lifestyle', name: 'Lifestyle', slug: 'lifestyle' },
  { id: 'service', name: 'Service', slug: 'service' },
]

export const demoApplications = [
  { id: 'APL-2048', campaign: demoCampaigns[0], status: 'IN_PROGRESS', appliedAt: '2026-08-12T08:00:00Z', dueAt: '2026-08-24T08:00:00Z' },
  { id: 'APL-1984', campaign: demoCampaigns[1], status: 'UNDER_REVIEW', appliedAt: '2026-08-08T08:00:00Z', submissionUrl: 'https://www.tiktok.com/@creator/video/1234567890123456789' },
  { id: 'APL-1832', campaign: demoCampaigns[4], status: 'VALIDATED', appliedAt: '2026-07-28T08:00:00Z', validViews: 12500, earningAmount: 250000 },
]

export const demoLedger = [
  { id: 'LDG-9182', transactionType: 'EARNING_RELEASED', direction: 'CREDIT', amount: 250000, reason: 'Morning Ritual di Nala', createdAt: '2026-08-14T09:30:00Z' },
  { id: 'LDG-9071', transactionType: 'WITHDRAWAL_PAID', direction: 'DEBIT', amount: 300000, reason: 'Penarikan ke BCA •••• 4812', createdAt: '2026-08-09T12:10:00Z' },
  { id: 'LDG-8998', transactionType: 'EARNING_RELEASED', direction: 'CREDIT', amount: 187500, reason: 'Cerita Pedas Mie Bang Jono', createdAt: '2026-08-03T07:45:00Z' },
]
